import React from 'react';
import markWhite from '../../assets/flik-mark-white.png';

/**
 * FLIK logo: the "FLIK" wordmark next to the brand mark (a hand doing the
 * "flick"/snap gesture with gold accents). The mark is a white-recoloured
 * version of the favicon, so it is meant for dark surfaces (the promo panel,
 * the private home). The wordmark inherits `currentColor`.
 */
function FlikLogo({ className, height = 22 }) {
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 9,
        fontFamily: 'var(--flik-font-sans)',
        fontWeight: 800,
        fontSize: height,
        letterSpacing: '-0.04em',
        lineHeight: 1,
        color: 'currentColor',
      }}
    >
      FLIK
      <img
        src={markWhite}
        alt=""
        aria-hidden="true"
        style={{ height: Math.round(height * 1.5), width: 'auto', display: 'block' }}
      />
    </span>
  );
}

export default FlikLogo;
